import { render, staticRenderFns } from "./AuthCard.vue?vue&type=template&id=21ee50a0&scoped=true&lang=pug"
import script from "./AuthCard.vue?vue&type=script&lang=ts"
export * from "./AuthCard.vue?vue&type=script&lang=ts"
import style0 from "./AuthCard.vue?vue&type=style&index=0&id=21ee50a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee50a0",
  null
  
)

export default component.exports